module.exports = __webpack_public_path__ + "mine.jpg?fb926b3cd16b3aba6458b948bae69c91";